import { useMemo } from "react";

type TdProps = {
  isLastCell?: boolean;
  hasBorder?: boolean;
  align?: 'center' | 'start' | 'end';
  children: React.ReactNode;
}


export default function Td ({align = 'end', isLastCell = false, hasBorder = true, children}: TdProps) {
  const border = useMemo(() =>  !isLastCell && hasBorder, [isLastCell, hasBorder]);

  return (
    <td className={`px-3 py-2.5 text-[14px] leading-[21px] text-${align} border-izygray border-collapse ${!border ? "" : 'border-r'}`}>
      {children}
    </td>
  )
}